import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/joker/user/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/joker/user`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/joker/user`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(userId) {
  return request.send({
    url: `/joker/user?userId=${userId}`,
    method: "delete",
  });
}
// 启用 警用
export function enableUser(data) {
  return request.send({
    url: `/joker/user/status`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 详情
export function detailInfo(userId) {
  return request.send({
    url: `/joker/user?userId=${userId}`,
    method: "get",
  });
}
